module.exports = __webpack_public_path__ + "media/images/element/rocket-1ffff87f53575adfc6bbaf7acdeb56ea.svg";